import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { COMPETITORS } from "../data/competitors";
import Reveal from "../components/Reveal";
import { useSeo, breadcrumbLd } from "../lib/seo";

export default function VsIndex() {
  useSeo({
    title: "Aesthetiq vs the competition — honest comparisons",
    description: "Honest, side-by-side comparisons of Aesthetiq against FaceKit, Umax, LooksMax AI and every major AI face-analysis and looksmaxxing app.",
    path: "/vs",
    jsonLd: breadcrumbLd([{ name: "Home", path: "/" }, { name: "Compare", path: "/vs" }]),
  });

  return (
    <div className="container py-16">
      <Reveal>
        <span className="label-eyebrow">Compare</span>
        <h1 className="mt-3 font-display text-5xl sm:text-6xl">How Aesthetiq compares.</h1>
        <p className="mt-4 max-w-2xl text-muted-foreground">No spin. Here's where each competitor is genuinely strong, and where Aesthetiq wins — so you can choose what's right for you.</p>
        <div className="mt-6 flex flex-wrap gap-3">
          <Link to="/best-ai-face-analysis-tool" className="rounded-full border border-border px-4 py-1.5 text-sm transition hover:border-primary/50">Best AI face analysis tools →</Link>
          <Link to="/best-looksmaxxing-app" className="rounded-full border border-border px-4 py-1.5 text-sm transition hover:border-primary/50">Best looksmaxxing app →</Link>
        </div>
      </Reveal>

      <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {COMPETITORS.map((c, i) => (
          <Reveal key={c.slug} delay={i * 0.03}>
            <Link to={`/vs/${c.slug}`} className="flex h-full flex-col rounded-xl border border-border bg-card p-6 transition hover:border-primary/40" data-testid={`vs-card-${c.slug}`}>
              <h2 className="font-display text-2xl">Aesthetiq <span className="text-muted-foreground">vs</span> {c.name}</h2>
              <p className="mt-1 text-xs text-muted-foreground">{c.platform}</p>
              <p className="mt-3 flex-1 text-sm text-muted-foreground">{c.tagline}</p>
              <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-primary">Read comparison <ArrowRight className="h-4 w-4" /></span>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
